import { render, staticRenderFns } from "./CommunityUserCard.vue?vue&type=template&id=cae63674&scoped=true&"
import script from "./CommunityUserCard.vue?vue&type=script&lang=js&"
export * from "./CommunityUserCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityUserCard.vue?vue&type=style&index=0&id=cae63674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae63674",
  null
  
)

export default component.exports